export default __webpack_public_path__ + "static/media/BETA.20f131a0.svg";